import { Pcr } from '../../lib/types/models/pcr/pcr'
import { PcrInput } from '../../lib/types/models/pcr/pcr-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updatePcr(data: UpdateInput<PcrInput>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.pcr.update.url, { id }))
    .patch<Pcr, Partial<PcrInput>>(rest)
}
